import { ColorSets } from "../../../_colorSets";

export enum AvatarSize {
  Small = "small",
  Regular = "regular",
}

export const CreateAvatarDataUri = (name: string, size: number): string => {
  if (typeof window !== "undefined") {
    const config: {
      name: string;
      size: number;
    } = {
      name: name || "",
      size: size || 36,
    };

    const colours = ColorSets.avatars;

    const nameSplit = String(config.name || "")
      .toUpperCase()
      .split(" ");
    let initials;
    let canvas;

    if (nameSplit.length === 1) {
      initials = nameSplit[0] ? nameSplit[0].charAt(0) : "?";
    } else {
      initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
    }

    if (window.devicePixelRatio) {
      config.size *= window.devicePixelRatio;
    }

    const charIndex = (initials === "?" ? 72 : initials.charCodeAt(0)) - 64;
    const colourIndex = charIndex % colours.length;
    canvas = document.createElement("canvas") as HTMLCanvasElement;
    canvas.width = config.size;
    canvas.height = config.size;
    const context = canvas.getContext("2d");

    if (context) {
      context.fillStyle = colours[colourIndex - 1];
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.font = `${Math.round(canvas.width / 2)}px Arial`;
      context.textAlign = "center";
      context.fillStyle = "#FFF";
      context.fillText(initials, config.size / 2, config.size / 1.5);
    }

    const dataURI = canvas.toDataURL();
    canvas = null;

    return dataURI;
  }
};

export const init = () => {
  document.querySelectorAll("img[avatar]").forEach((img) => {
    const name = img.getAttribute("avatar") as string;
    const size = img.getBoundingClientRect().width;
    (img as HTMLImageElement).src = CreateAvatarDataUri(name, size);
    img.removeAttribute("avatar");
    img.setAttribute("alt", name);
  });
};

export default {
  init,
  CreateAvatarDataUri,
  AvatarSize,
};
